module.exports = __webpack_public_path__ + "img/风筝 2.a31fdd3c.png";